import React from "react";
import { Container, Row, Col, Badge, Button } from "react-bootstrap";

const FeaturedCourses = () => {
    return (
        <section className=" py-5">
            <Container>

                {/* COURSE 1 */}
                <Row className="align-items-center course-row mb-5">
                    <Col lg={6}>
                        <div className="course-image">
                            {/* <span className="price-badge">Price: $15</span> */}
                            <img
                                src="f-1.jpg"
                                alt="Course"
                                className="img-fluid"
                            />
                        </div>
                    </Col>

                    <Col lg={6}>
                        <div className="course-content">
                            <Badge className="featured-badge">Digital Marketing</Badge>
                            <h4>HTML5 & CSS For Beginners</h4>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur. Phasellus sollicitudin
                                et nunc ac efficitur. Sed ligula nulla, molestie quis ligula in,
                                eleifend rhoncus ipsum.
                            </p>
                            <div className="author">
                                <img src="user.jpg" alt="" />
                                <span>
                                    William Parker <small>Developer</small>
                                </span>
                            </div>
                            <div className="course-meta mt-4">
                                {/* <span className="students">120 Students</span> */}
                                <Button className="btn-grad border-0" size="sm">
                                    Enroll Now
                                </Button>
                                <Button className="btn-grad border-0" size="sm">
                                    Enroll Now
                                </Button>
                            </div>

                        </div>
                    </Col>
                </Row>

                {/* COURSE 2 */}
                <Row className="align-items-center course-row  mt-5">
                    <Col lg={6}>
                        <div className="course-content">
                            <Badge className="featured-badge">Website Development</Badge>
                            <h4>HTML5 & CSS For Beginners</h4>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur. Phasellus sollicitudin
                                et nunc ac efficitur. Sed ligula nulla, molestie quis ligula in,
                                eleifend rhoncus ipsum.
                            </p>
                            <div className="author">
                                <img src="user.jpg" alt="" />
                                <span>
                                    William Parker <small>Developer</small>
                                </span>
                            </div>
                            <div className="course-meta mt-4">
                                {/* <span className="students">120 Students</span> */}
                                <Button className="btn-grad border-0" size="sm">
                                    Enroll Now
                                </Button>
                                <Button className="btn-grad border-0" size="sm">
                                    Enroll Now
                                </Button>

                            </div>
                        </div>
                    </Col>

                    <Col lg={6}>
                        <div className="course-image">
                            {/* <span className="price-badge">Price: $15</span> */}
                            <img
                                src="f-2.jpg"
                                alt="Course"
                                className="img-fluid"
                            />
                        </div>
                    </Col>
                </Row>

            </Container>
        </section>
    );
};

export default FeaturedCourses;
